import { forwardRef } from 'react';
import UIIconButton from 'UIComponents/button/UIIconButton';
import UIIcon from 'UIComponents/icon/UIIcon';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
export const ComposerSettingsButton = /*#__PURE__*/forwardRef(({
  menuOpen,
  onClick
}, settingsButtonRef) => {
  return /*#__PURE__*/_jsx(UIIconButton, {
    "data-test-id": "ai-settings-button",
    tooltip: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "composer-ui.settings.tooltip"
    }),
    buttonRef: settingsButtonRef,
    tooltipProps: Object.assign({}, menuOpen && {
      open: false
    }, {
      placement: 'top'
    }),
    use: "transparent",
    onClick: onClick,
    children: /*#__PURE__*/_jsx(UIIcon, {
      name: 'settings'
    })
  });
});
ComposerSettingsButton.displayName = 'SettingsButton';